import React from 'react';
import {render} from 'react-dom';
import plausibleInit from 'plausible-tracker/build/main/index';
import {BrowserFetcher} from '@/common/services/fetcher/BrowserFetcher';
import {LocalizerProvider} from '@/common/services/localizer';
import {InformersAPI} from '@/informers/services/InformersAPI';
import {OverlayContainerContext} from '@/common/contexts/OverlayContainerContext';
import {ServicesContext} from '@/informers/contexts/ServicesContext';
import {ErrorBoundary} from '@/common/components/ErrorBoundary/ErrorBoundary';
import {App} from '@/informers/components/app';
import {localizationResources} from '@/informers/locales';
import domains from '@/domains.json';

// TODO add analytic in the html page

(async function initialize() {
	// Initialize internal services
	const fetcher = new BrowserFetcher();
	const informersAPI = new InformersAPI(fetcher);

	// Read the page language
	const defaultLanguage = domains[DOMAIN_NAME].primaryLanguage;
	const searchParams = new URLSearchParams(location.search);
	const language = searchParams.get('lang') || defaultLanguage;

	// Render the application
	const container = document.querySelector('.root-app');
	const overlayContainer = document.querySelector('.root-overlay');

	const domainConfig = domains[DOMAIN_NAME];

	/** Plausible analytics report service */
	const plausibleAnalytics = plausibleInit({
		domain: domainConfig.analytics.plausible.siteDomain,
		apiHost: domainConfig.analytics.plausible.reportEndpoint,
		trackLocalhost: true,
	});

	plausibleAnalytics.trackPageview({url: `${location.origin}/informers`});

	const appRender = () => {
		render(
			<ErrorBoundary
				onError={error => {
					console.log('Render error catcher', error);
					// TODO handle an error and retry
				}}>
				<OverlayContainerContext.Provider value={overlayContainer}>
					<ServicesContext.Provider value={{informersAPI}}>
						<LocalizerProvider language={language} resources={localizationResources}>
							<App />
						</LocalizerProvider>
					</ServicesContext.Provider>
				</OverlayContainerContext.Provider>
			</ErrorBoundary>,
			container,
		);
	};

	appRender();

	if (module.hot) {
		module.hot.accept('@/components/informers/app', () => {
			appRender();
		});
	}
})();
